export const serviceCategories = [
  {
    id: 'heating',
    title: 'Heating',
    icon: 'ri-fire-line',
    desc: 'Furnace installation, repair & maintenance for year-round warmth.',
    path: '/heating',
    color: '#C41E3A',
  },
  {
    id: 'air-conditioning',
    title: 'Air Conditioning',
    icon: 'ri-temp-cold-line',
    desc: 'Central AC, ductless systems, and cooling upgrades.',
    path: '/air-conditioning',
    color: '#0C2340',
  },
  {
    id: 'heat-pumps',
    title: 'Heat Pumps',
    icon: 'ri-recycle-line',
    desc: 'Efficient heat pump systems for heating and cooling in one unit.',
    path: '/heat-pumps',
    color: '#C41E3A',
  },
  {
    id: 'plumbing',
    title: 'Plumbing',
    icon: 'ri-drop-line',
    desc: 'Full plumbing services from repairs to complete installs.',
    path: '/plumbing',
    color: '#0C2340',
  },
  {
    id: 'electrical',
    title: 'Electrical',
    icon: 'ri-flashlight-line',
    desc: 'Panel upgrades, wiring, and electrical safety inspections.',
    path: '/electrical',
    color: '#C41E3A',
  },
  {
    id: 'water-heaters',
    title: 'Water Heaters',
    icon: 'ri-water-flash-line',
    desc: 'Tank and tankless water heater installation and service.',
    path: '/water-heaters',
    color: '#0C2340',
  },
  {
    id: 'insulation',
    title: 'Insulation',
    icon: 'ri-building-line',
    desc: 'Attic, wall and crawlspace insulation for energy savings.',
    path: '/insulation',
    color: '#C41E3A',
  },
  {
    id: 'air-quality',
    title: 'Air Quality',
    icon: 'ri-windy-line',
    desc: 'Filtration, UV systems, and whole-home air purification.',
    path: '/air-quality',
    color: '#0C2340',
  },
  {
    id: 'maintenance-plans',
    title: 'Maintenance Plans',
    icon: 'ri-shield-check-line',
    desc: 'Annual protection plans with priority service and discounts.',
    path: '/maintenance-plans',
    color: '#C41E3A',
  },
  {
    id: 'energy-efficiency',
    title: 'Energy Efficiency',
    icon: 'ri-leaf-line',
    desc: 'Whole-home energy audits, upgrades, and rebate guidance.',
    path: '/rebates-incentives',
    color: '#0C2340',
  },
];

export const serviceNavLinks = [
  { label: 'Heating', path: '/heating' },
  { label: 'Air Conditioning', path: '/air-conditioning' },
  { label: 'Heat Pumps', path: '/heat-pumps' },
  { label: 'Plumbing', path: '/plumbing' },
  { label: 'Electrical', path: '/electrical' },
  { label: 'Water Heaters', path: '/water-heaters' },
  { label: 'Insulation', path: '/insulation' },
  { label: 'Air Quality', path: '/air-quality' },
];
